import * as angular from 'angular';
import * as _ from 'lodash';

import { ComponentDefinition, ConnectionPointQuerySetDto, ConnectionPointType } from '../../models';
import { IConnectionPointService } from '../../services';
import { guidEmpty } from '../../common/';

class ConnectionPointQuerySetSelectorController implements angular.IComponentController {
    
    connectionPointType: ConnectionPointType;
    dataType: any;
    filtered: ConnectionPointQuerySetDto[];
    formController: angular.IFormController;
    model: string;
    onChange: () => void;
    property: string;
    queries: ConnectionPointQuerySetDto[] = [];
    required: boolean;
    
    static $inject = ['connectionPointService'];
    constructor(private _connectionPointService: IConnectionPointService) {
    }

    $onInit() {
        this._connectionPointService.getAllQueries().then(data => {
            this.queries = data;
            this.filter();
            this.validate();
        });
    }

    $onChanges() {
        this.filter();
        this.validate();
    }

    filter() {
        this.filtered = _.filter(this.queries, q => q.connectionPointType === this.connectionPointType);
    }

    validate() {
        if (this.formController && this.formController[this.property]) {
            const isValid = this.required
                && this.queries
                && (!!this.model && this.model !== guidEmpty)
                && _.some(this.queries, q => q.guid === this.model);
            this.formController[this.property].$setValidity('required', isValid);
        }
    }
}

export const wtConnectionPointQuerySetSelector: ComponentDefinition = {
    componentId: 'wtConnectionPointQuerySetSelector',
    controller: ConnectionPointQuerySetSelectorController,
    controllerAs: 'vm',
    template: require('./connectionPointQuerySetSelector.component.html'),
    bindings: {
        formController: '<',
        model: '=',
        placeholder: '@?',
        required: '<?',
        property: '<?',
        onChange: '&?',
        connectionPointType: '<'
    }
};